import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Form,
} from 'semantic-ui-react';
import MarkdownText from './MarkdownText';
import { withTranslation } from 'react-i18next';
import { namespaces, TRANSLATION_FILES } from '../constants/translation';

class TextFieldMarkdownPreview extends Component {
  static propTypes = {
    data: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    labelName: PropTypes.string.isRequired,
    onDefaultInputChange: PropTypes.func.isRequired,
  }
  static getPropsToState = (props) => {
    const data = props.data;
    const name = props.name;
    const labelName = props.labelName;
    return {
      data,
      name,
      isPreview: false,
      labelName,
    };
  }
  constructor(props) {
    super(props);
    const state = TextFieldMarkdownPreview.getPropsToState(props);
    this.state = {
      ...state,
    };
  }
  componentWillReceiveProps(nextProps) {
    const state = nextProps;
    this.setState({
      ...state,
    });
  }
  handleTextAreaChange = (e, { value }) => {
    this.setState({ data: value }, () => {
      // trigger changes to parent component
      this.props.onDefaultInputChange(e, { value, name: this.state.name });
    });
  }
  toggleCheckboxChange = (e) => {
    e.preventDefault();
    this.setState({
      isPreview: !this.state.isPreview,
    });
  }
  render() {
    const {
      data,
      name,
      labelName,
      isPreview,
    } = this.state;
    const { t } = this.props;
    return (
      <div>
        <Form.Checkbox
          label={t('Show Preview')}
          name="isPreview"
          checked={isPreview}
          onChange={this.toggleCheckboxChange}
        />
        <Form.TextArea
          label={labelName}
          name={name}
          value={data}
          onChange={this.handleTextAreaChange}
        />
        {
          isPreview ? (
            <Form.Field name={name}>
              <label htmlFor={name}>{t('Preview', { ns: TRANSLATION_FILES.translation })}</label>
              <MarkdownText content={data} />
            </Form.Field>
          ) : null
        }
      </div>
    );
  }
}

export default withTranslation(namespaces)(TextFieldMarkdownPreview);



// WEBPACK FOOTER //
// ./src/components/TextFieldMarkdownPreview.jsx